import { Component, Input } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Menu } from '../../models/menu.model';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrl: './side-bar.component.scss'
})
export class SideBarComponent {

  @Input() menuData: Array<Menu> = [];

  public isCollapsed = true;

  public skeletonRows: Array<string> = [
    'col-7',
    'col-6',
    'col-8',
    'col-6',
    'col-7',
    'col-8',
    'col-6',
    'col-8',
    'col-7',
    'col-6'
  ];

  constructor(
    public authService: AuthService
  ) {

  }

}
